import BaseComponent from '@/components/base';
export default class RecommendationCard extends BaseComponent {
  render() {
    return `
       <style>
        .card {
          display: flex;
          width: ${this.isSmall ? 'unset' : '400px'};
          border: 1px solid #ccc;
          border-radius: 8px;
          overflow: hidden;
          box-shadow: 0 2px 8px rgba(0,0,0,0.1);
          font-family: sans-serif;
          justify-content: space-between;
          background: #f1f9f7;
          text-decoration: none;
          color: inherit;
        }

        .card img {
          width: 30%;
          height: auto;
          object-fit: contain;
          background: white;
          max-height: 150px;
        }

        .card .content {
          padding: 16px;
          box-sizing: border-box;
          display: flex;
          flex-direction: column;
          justify-content: center;
        }

        .card h3 {
          margin: 0 0 8px 0;
          font-size: 0.9em;
          line-height: 20px;
          font-weight: normal;
        }

        .card p {
          margin: 0;
          color: #555;
          font-size: 0.8em;
        }

       </style>
       <a
        href="${this.link}"
        class="card"
        target="_blank"
        rel="noopener noreferrer"
        >
        <div class="content">
          <h3>${this.title}</h3>
          <p>${this.description}</p>
        </div>
        <img src="${this.image}" alt="${this.title}">
      </a>
    `;
  }

  get title() {
    return this.getAttribute('title');
  }

  get description() {
    return this.getAttribute('description');
  }

  get link() {
    return this.getAttribute('link');
  }

  get linkTitle() {
    return this.getAttribute('link-title');
  }

  get image() {
    return this.getAttribute('image');
  }
}
